$(window).on('scroll', function() {
    if ($(this).scrollTop() >= 40) {
        $('body').addClass('sticky_header');
    } else {
        $('body').removeClass('sticky_header');
    }
});

// jQuery('.slides').slick({
//   infinite: true,
//   arrows: false,
//   slidesToShow: 1,
//   slidesToScroll: 1
//   });


$('.discover-slider ul').slick({
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3500,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 3500,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
        infinite: true
      }
    }
  ]
});


$(document).ready(function () {
  function initSlider() {
    if ($(window).width() > 768) {
      if (!$('.discover-slider ul').hasClass('slick-initialized')) {
        $('.discover-slider ul').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          fade: true,
          arrows: true,
          dots: false,
        });
      }
    } else {
      if ($('.discover-slider ul').hasClass('slick-initialized')) {
        $('.discover-slider ul').slick('unslick'); // Destroy slider on mobile
      }
    }
  }

  // Run on document load
  initSlider();

  // Re-run on window resize
  $(window).resize(function () {
    initSlider();
  });
});






















  $('.embroidery-collection-list').slick({
      infinite: true,
      slidesToShow: 4, // Number of collections shown
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });


    $('.bestsellers-slider ul').slick({
      infinite: true,
      slidesToShow: 4, // Adjust as needed
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

$('.what-occasion-slider ul').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$(".faq_btn").click(function() {
     $('html, body').animate({
         scrollTop: $("#faqSec").offset().top - 100
     }, 500);
 });

 $('.tab-a').click(function(){  
    $(".tab-content").removeClass('tab-active');
    $(".tab-content[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
    $(".tab-a").removeClass('active-a');
    $(this).parent().find(".tab-a").addClass('active-a');
});
  // $('.ac_btn').click(function() {
  //   $('.accord_content').slideUp();
  //   $('.accord_content').removeClass("active");
  //   if ($(this).parent().find(".accord_content").css('display') == 'none') {
  //       $(this).parent().find(".accord_content").slideDown();
  //       $(this).parent().find(".accord_content").addClass("active");
  //   }else{
  //     $(this).parent().find(".accord_content").slideUp();
  //      $(this).parent().find(".accord_content").removeClass("active");
  //   }
  // });


// $('.highlight-slide').slick({
//  infinite: true,
//  dots: true,
//  arrows: false,
//  slidesToShow: 1,
//  slidesToScroll: 1
// });


$('.testimonial-slider').slick({
  dots: true,
  arrows: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.blog-slider ul').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$('.discover_blog-slider ul').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});




$('.crafts-slider ul').slick({
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3500,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 3500,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true
      }
    }
  ]
});






$('.gallery-large-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: false,
  infinite: false,
  asNavFor: '.gallery-thumb-slider'
});
$('.gallery-thumb-slider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.gallery-large-slider',
  dots: false,
  arrows: true,
  infinite: false,
  focusOnSelect: true,
  vertical: true,
  verticalSwiping: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: false,
        verticalSwiping: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: false,
        verticalSwiping: false
      }
    }
  ]
});

$('.new_in-collection-list').slick({
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 5000,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.accordian-title').click(function() {
    $('.accordian-content').slideUp();
    $('.accordian-title').parent().removeClass("active");
    if($(this).parent().find(".accordian-content").css('display') == 'none') {
        $(this).parent().find(".accordian-content").slideDown();
      $(this).parent().addClass("active");
    }else{
      $(this).parent().find(".accordian-content").slideUp();
      $(this).parent().removeClass("active");
    }
});

$(document).ready(function() {
    // Initially show the first item's content and set its icon to minus
    $('.accord_block:first-child .accord_content').slideDown();
    $('.accord_block:first-child .ac_btn').append('<span class="toggle-icon">-</span>');

    // Click event for accordion headers
    $('.ac_btn').click(function() {
      var content = $(this).next('.accord_content');
      var icon = $(this).find('.toggle-icon');

      // If the clicked content is not already visible
      if (!content.is(':visible')) {
        // Close all accordions
        $('.accord_content').slideUp();
        $('.toggle-icon').text('+');

        // Open the clicked accordion and change the icon to minus
        content.slideDown();
        icon.text('-');
      } else {
        // If the clicked content is visible, close it and reset the icon to plus
        content.slideUp();
        icon.text('+');
      }
    });

    // Add the initial plus icon for each accordion except the first one
    $('.accord_block .ac_btn').not(':first').append('<span class="toggle-icon">+</span>');
  });

$(document).ready(function(){
      ///***** START SLICK WITH PROGRESSBAR****///
		  // Slick Slide Counters
		  var $mainslider = $('.slides')
				$mainslider.on('init', function(event, slick) {
					$(this).append('<div class="slick-counter"><span class="current"></span><div class="slider-progress"><div class="progress"></div></div><span class="total"></span></div>');
					$('.current').text(slick.currentSlide + 1);
					$('.total').text(slick.slideCount);
				  })
			  $mainslider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				$('.current').text(nextSlide + 1);
			  });
		  
		  // Slick Slider Options
		  $mainslider.slick({
				draggable: true,
				arrows: false,
				dots: false,
				//fade:true,
				infinite: true,
				speed: 1000,
				mobileFirst: true,
				pauseOnHover: true,
			  });
		  
		  // Slider Progressbar Start Here
		  var time = 3;
		  var $bar,
			$mainslider,
			isPause,
			tick,
			percentTime;  
		
		  $bar = $('.slider-progress .progress');
		
		  function startProgressbar() {
			resetProgressbar();
			percentTime = 0;
			isPause = false;
			tick = setInterval(interval, 15);
		  }
		
		  function interval() {
			if (isPause === false) {
			  percentTime += 1 / (time + 0.1);
			  $bar.css({
				width: percentTime + "%"
			  });
			  if (percentTime >= 100) {
				$mainslider.slick('slickNext');
			  }
			}
		  }
		  function resetProgressbar() {
			$bar.css({
			  width: 0 + '%'
			});
			clearTimeout(tick);
		  }
		  // Reset Progressbar When Slide Change
		   $mainslider.on('afterChange', function(event, slick, currentSlide) {
			  startProgressbar();
		  });
		  
		 $('.sliderwrap').on({
			mouseenter: function() {
			  isPause = true;
			},
			mouseleave: function() {
			  isPause = false;
			}
		  })
		startProgressbar();

 });

$(document).ready(function(){
  // 2
  
  var $highlightslid = $('.highlight-slide')
				$highlightslid.on('init', function(event, slick) {
					$(this).append('<div class="slick-counter"><span class="current"></span><div class="slider-progress"><div class="progress"></div></div><span class="total"></span></div>');
					$('.current').text(slick.currentSlide + 1);
					$('.total').text(slick.slideCount);
				  })
			  $highlightslid.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				$('.current').text(nextSlide + 1);
			  });
		  
		  // Slick Slider Options
		  $highlightslid.slick({
				draggable: true,
				arrows: false,
				dots: false,
				//fade:true,
				infinite: true,
				speed: 1000,
                adaptiveHeight: true,
				mobileFirst: true,
				pauseOnHover: true,
			  });
		  
		  // Slider Progressbar Start Here
		  var time = 3;
		  var $barh,
			$highlightslid,
			isPause,
			tick,
			percentTime;

  $barh = $('.slider-progress .progress');
		
		  function startProgressbar() {
			resetProgressbar();
			percentTime = 0;
			isPause = false;
			tick = setInterval(interval, 15);
		  }
		
		  function interval() {
			if (isPause === false) {
			  percentTime += 1 / (time + 0.1);
			  $barh.css({
				width: percentTime + "%"
			  });
			  if (percentTime >= 100) {
				$highlightslid.slick('slickNext');
			  }
			}
		  }
		  function resetProgressbar() {
			$barh.css({
			  width: 0 + '%'
			});
			clearTimeout(tick);
		  }
		  // Reset Progressbar When Slide Change
		   $highlightslid.on('afterChange', function(event, slick, currentSlide) {
			  startProgressbar();
		  });
		  
		 $('.sliderwrap').on({
			mouseenter: function() {
			  isPause = true;
			},
			mouseleave: function() {
			  isPause = false;
			}
		  })
		startProgressbar();
  //2
    });


//responsive tab js

    $(document).ready(function() {
        //Horizontal Tab
        $('#parentHorizontalTab').easyResponsiveTabs({
            type: 'default', //Types: default, vertical, accordion
            width: 'auto', //auto or any width like 600px
            fit: true, // 100% fit in a container
            tabidentify: 'hor_1', // The tab groups identifier
            activate: function(event) { // Callback function if tab is switched
                var $tab = $(this);
                var $info = $('#nested-tabInfo');
                var $name = $('span', $info);
                $name.text($tab.text());
                $info.show();
            }
        });

        // Child Tab
        $('#ChildVerticalTab_1').easyResponsiveTabs({
            type: 'vertical',
            width: 'auto',
            fit: true,
            tabidentify: 'ver_1', // The tab groups identifier
            activetab_bg: '#fff', // background color for active tabs in this group
            inactive_bg: '#F5F5F5', // background color for inactive tabs in this group
            active_border_color: '#c1c1c1', // border color for active tabs heads in this group
            active_content_border_color: '#5AB1D0' // border color for active tabs contect in this group so that it matches the tab head border
        });

        //Vertical Tab
        $('#parentVerticalTab').easyResponsiveTabs({
            type: 'vertical', //Types: default, vertical, accordion
            width: 'auto', //auto or any width like 600px
            fit: true, // 100% fit in a container
            closed: 'accordion', // Start closed if in accordion view
            tabidentify: 'hor_1', // The tab groups identifier
            activate: function(event) { // Callback function if tab is switched
                var $tab = $(this);
                var $info = $('#nested-tabInfo2');
                var $name = $('span', $info);
                $name.text($tab.text());
                $info.show();
            }
        });
    });


// if the URL contains a hashtag, trigger click on that tab.

// if (window.location.hash !== '') {
//     var thisUrlHash = window.location.hash;
//     $('#C13').find(thisUrlHash).click();
// }

// // add the class .tab-link to any old <a> tag, set the href attribute to the #id of the tab you want to switch to.
// $('.tab-link').click(function(e){
//     var thisHref = $(this).attr('href');

//     e.preventDefault();
//     $(thisHref).click();
// });



// inn tab js vision


$(document).ready(function() {
  console.log("document ready");

  const labels = document.querySelectorAll(".accordion-item__label");
  const tabs = document.querySelectorAll(".accordion-tab");

  function toggleShow() {
    const target = this;
    const item = target.classList.contains("accordion-tab")
      ? target
      : target.parentElement;
    const group = item.dataset.actabGroup;
    const id = item.dataset.actabId;

    tabs.forEach(function(tab) {
      if (tab.dataset.actabGroup === group) {
        if (tab.dataset.actabId === id) {
          tab.classList.add("accordion-active");
        } else {
          tab.classList.remove("accordion-active");
        }
      }
    });

    labels.forEach(function(label) {
      const tabItem = label.parentElement;

      if (tabItem.dataset.actabGroup === group) {
        if (tabItem.dataset.actabId === id) {
          tabItem.classList.add("accordion-active");
        } else {
          tabItem.classList.remove("accordion-active");
        }
      }
    });
  }

  labels.forEach(function(label) {
    label.addEventListener("click", toggleShow);
  });

  tabs.forEach(function(tab) {
    tab.addEventListener("click", toggleShow);
  });

});














// contact page accordion


$(document).ready(function() {
  // Ensure the default active accordion shows the minus icon
  $('.accordion-block.active').find('.toggle-icon').text('−'); // This sets the minus for the initially active one

  // When the accordion title is clicked
  $('.accordian-title-contactp').click(function() {
    // Check if the clicked accordion is already active (open)
    if ($(this).next('.accordian-answer').is(':visible')) {
      // Close the accordion and change the icon back to +
      $(this).next('.accordian-answer').slideUp();
      $(this).parent().removeClass('active');
      $(this).find('.toggle-icon').text('+');
    } else {
      // Close any open accordion and reset all icons to +
      $('.accordian-answer').slideUp();
      $('.accordion-block').removeClass('active');
      $('.toggle-icon').text('+');
      
      // Open the clicked accordion and change the icon to -
      $(this).next('.accordian-answer').slideDown();
      $(this).parent().addClass('active');
      $(this).find('.toggle-icon').text('−');
    }
  });
});


// contact information tab

$(document).ready(function() {
  // Hide all tab contents except the active one
  $('.tab-content-contact').not('.active').hide();
  
  // When a tab is clicked
  $('.contact-tab-nav ul li').click(function() {
    // Remove active class from all tabs
    $('.contact-tab-nav ul li').removeClass('active');
    // Add active class to the clicked tab
    $(this).addClass('active');
    
    // Get the ID of the clicked tab
    var tabId = $(this).attr('id');
    
    // Hide all tab contents
    $('.tab-content-contact').removeClass('active').hide();
    
    // Show the tab content that corresponds to the clicked tab
    $('#' + tabId + '-enquiries').addClass('active').show();
  });
});


$('a[href^="#"]').on('click',function (e) {
	    e.preventDefault();
       
	    var target = this.hash;
	    var $target = $(target);
        var goto = $target.offset().top - 150;
	    $('html, body').stop().animate({
	        'scrollTop': goto
	    }, 1500, 'swing', function () {
	        //window.location.hash = target;
	    });
});

$('.read-more').click(function(){
  if ($(this).text() == "Read More") {
     $(this).text("Read Less");
     $(this).parent().find('.more-text').fadeIn();
  } else {
     $(this).text("Read More"); 
     $(this).parent().find('.more-text').fadeOut();
  } 
});




function toggleContent(button) {
  const infoContainer = button.closest('.h_info');
  infoContainer.classList.toggle('expanded');
  
  if (infoContainer.classList.contains('expanded')) {
    button.textContent = 'Show Less';
  } else {
    button.textContent = 'Show More';
  }
}


// announcement ber


  document.addEventListener("DOMContentLoaded", function () {
    $(".announcement-ber").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 9000,
      arrows: false,
      dots: false
    });

    // Optional: Close announcement functionality
    document.querySelectorAll(".announcement__close").forEach(function (button) {
      button.addEventListener("click", function () {
        const slide = this.closest(".announcement-slide");
        if (slide) {
          slide.remove();
          $(".slick-slider").slick("setPosition"); // Adjust slider after removal
        }
      });
    });
  });




//social sharing
function toggleSharePopup() {
  const popup = document.getElementById('share-popup');
  popup.classList.toggle('active');
}


// size Chart js

document.addEventListener("DOMContentLoaded", function () {
  const sizeChartButton = document.querySelector(".size-chart-button");
  const sizeChartPanel = document.querySelector(".size-chart-panel");
  const closePanelButton = document.querySelector(".close-panel");
  const overlayBackground = document.querySelector(".overlay-background");

  const tabLinks = document.querySelectorAll(".tab-link");
  const tabContents = document.querySelectorAll(".tab-content");

  // Open the size chart panel
  sizeChartButton.addEventListener("click", () => {
    sizeChartPanel.classList.add("active");
    overlayBackground.classList.add("active");
  });

  // Close the size chart panel
  closePanelButton.addEventListener("click", () => {
    sizeChartPanel.classList.remove("active");
    overlayBackground.classList.remove("active");
  });

  // Close the panel when clicking on the overlay
  overlayBackground.addEventListener("click", () => {
    sizeChartPanel.classList.remove("active");
    overlayBackground.classList.remove("active");
  });

  // Tab functionality
  tabLinks.forEach((tabLink) => {
    tabLink.addEventListener("click", () => {
      // Remove active class from all tabs
      tabLinks.forEach((link) => link.classList.remove("active"));
      tabContents.forEach((content) => content.classList.add("hidden"));

      // Add active class to clicked tab and show corresponding content
      tabLink.classList.add("active");
      const targetTab = document.getElementById(tabLink.dataset.tab);
      targetTab.classList.remove("hidden");
    });
  });

  // Show the first tab by default
  document.querySelector(".tab-link.active").click();
});


// our Store Tab Js

$(document).ready(function () {
$('#horizontalTab').easyResponsiveTabs({
type: 'default', //Types: default, vertical, accordion           
width: 'auto', //auto or any width like 600px
fit: true,   // 100% fit in a container
closed: 'accordion', // Start closed if in accordion view
activate: function(event) { // Callback function if tab is switched
var $tab = $(this);
var $info = $('#tabInfo');
var $name = $('span', $info);
$name.text($tab.text());
$info.show();
}
});
$('#verticalTab').easyResponsiveTabs({
type: 'vertical',
width: 'auto',
fit: true
});
});





// Fading slider home page js


document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".fading-images__container");
  const slides = container.querySelectorAll(".fading-images__slide");
  const interval = container.parentElement.getAttribute("data-interval") || 5000;

  let currentIndex = 0;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.classList.toggle("active", i === index);
    });
  }

  function startSlider() {
    showSlide(currentIndex);
    setInterval(() => {
      currentIndex = (currentIndex + 1) % slides.length;
      showSlide(currentIndex);
    }, interval);
  }

  if (slides.length > 0) {
    startSlider();
  }
});



document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.add-to-bag-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const button = this.querySelector('.add-to-bag-button');
      button.textContent = 'Adding...';
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(this))
      })
      .then(response => response.json())
      .then(data => {
        button.textContent = 'Added!';
        setTimeout(() => {
          button.textContent = 'Add to Bag';
          button.disabled = false;
        }, 2000);
        // ऑप्शनल: कार्ट अपडेट इवेंट ट्रिगर करें
      })
      .catch(error => {
        console.error('Error:', error);
        button.textContent = 'Error';
        setTimeout(() => {
          button.textContent = 'Add to Bag';
          button.disabled = false;
        }, 2000);
      });
    });
  });
});



